import React from "react";
import { Helmet } from "react-helmet";

interface BlogMetaProps {
  title: string;
  metaDescription: string;
  keywords: string;
  canonicalUrl: string;
  ogImage: string;
  articleSchema: string;
  dispensaryServiceSchema: string;
  breadcrumbSchema: string;
  localBusinessSchema: string;
}

const BlogMeta: React.FC<BlogMetaProps> = ({
  title,
  metaDescription,
  keywords,
  canonicalUrl,
  ogImage,
  articleSchema,
  dispensaryServiceSchema,
  breadcrumbSchema,
  localBusinessSchema,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* OpenGraph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="SLS Dispensary" />

      {/* Rich snippets for better SEO */}
      <script type="application/ld+json">{articleSchema}</script>
      <script type="application/ld+json">{dispensaryServiceSchema}</script>
      <script type="application/ld+json">{breadcrumbSchema}</script>
      <script type="application/ld+json">{localBusinessSchema}</script>
    </Helmet>
  );
};

export default BlogMeta;
